/**
 * Diagnostic tracing for time_logs writes.
 * Does not change sync behavior — logs only.
 */

import { getConnectivityState, isBrowserReportedOnline } from "./connectivity";
import { devLog } from "./devLog";

export function traceTimelogWrite({
  operation,
  path,
  sessionId,
  phase = "attempt",
  error = null,
  extra = {},
}) {
  devLog("[CP_TIMELOG_WRITE]", {
    phase,
    operation,
    path,
    sessionId: sessionId ?? null,
    executionContext: "document",
    hasServiceWorkerController:
      typeof navigator !== "undefined" &&
      Boolean(navigator.serviceWorker?.controller),
    navigatorOnLine: isBrowserReportedOnline(),
    connectivityState: getConnectivityState(),
    timestamp: new Date().toISOString(),
    error: error?.message || error || null,
    ...extra,
  });
}
